// import { createStore, applyMiddleware } from 'redux';
// import createSagaMiddleware from 'redux-saga';
// import logger from 'redux-logger';
// import reducer from './reducer';
// import rootSaga from './saga/index';

// export default function configureStore(initialState) {
//   const sagaMiddleware = createSagaMiddleware();
//   const store = createStore(
//     reducer,
//     initialState,
//     applyMiddleware(
//       sagaMiddleware, logger()
//     )
//   );
//   sagaMiddleware.run(rootSaga);
//   return store;
// };

import {createStore,compose,applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { thunk } from 'redux-thunk';
import reducer from './reducer';
import rootSaga from './saga/index';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, thunk];
const store = createStore(
    reducer,
    compose(applyMiddleware(...middlewares))
);
sagaMiddleware.run(rootSaga);
export default store;